module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "trs-simple-fade"
    }
  }, [(!_vm.hasUserAccepted) ? _c('div', {
    staticClass: "cookie-banner grid grid__base"
  }, [_c('div', {
    staticClass: "grid--container"
  }, [_c('div', {
    staticClass: "cookie-banner--row grid--row"
  }, [_c('div', {
    staticClass: "cookie-banner--message-col grid--col"
  }, [_c('h1', {
    staticClass: "u-reset u-reset__h2"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.text) + "\n                        "), _c('a', {
    staticClass: "cookie-banner--inline-link",
    attrs: {
      "href": _vm.link.path
    }
  }, [_vm._v(_vm._s(_vm.link.label))])])]), _vm._v(" "), _c('div', {
    staticClass: "grid--col cookie-banner--actions cookie-banner--actions-col "
  }, [_vm._t("actions", [_c('button', {
    staticClass: "btn btn__small btn__outline",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.confirm_label) + "\n                        ")])])], 2)])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a00acbf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a00acbf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-placeholders/cookie-banner/index.vue
// module id = 541
// module chunks = 7